<button kendoButton look="outline" [primary]="true" (click)="today()">
  Today
</button>
<button kendoButton look="clear" [primary]="false" (click)="prev()">
  &#60;
</button>
<button kendoButton look="clear" [primary]="false" (click)="next()">
  &#62;
</button>
<kendo-datepicker
  style="
    width: 0px;
    height: 0px;
    margin: 0px;
    padding: 0px;
    margin-top: 35px;
    margin-left: 10px;
    overflow: hidden;
  "
  #datePicker
  [(value)]="selectedDate"
  [readOnlyInput]="true"
  (valueChange)="onDateChange($event)"
></kendo-datepicker>

<button kendoButton look="outline" [primary]="true" (click)="openCalendar()">
  <span style="font-weight: normal">{{ this.dateText }}</span>
  <span>
    <span class="k-icon k-i-calendar k-color-primary calendar-icon"></span>
  </span>
</button>
